export const newLine = '\r\n'
